import React, { useEffect } from "react";
import { useState } from "react";
import styles from "./CountDown.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, useMediaQuery } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeTwoToneIcon from "@mui/icons-material/AccessTimeTwoTone";
import AlarmOnTwoToneIcon from "@mui/icons-material/AlarmOnTwoTone";
import EventTwoToneIcon from "@mui/icons-material/EventTwoTone";

const CountDown = ({ isLoggedIn }) => {
  const [clockDay, setClockDay] = useState();
  const [clockHour, setClockHour] = useState();
  const [clockMin, setClockMin] = useState();
  const [clockSecond, setClockSecond] = useState();
  let interval;
  const starterTime = () => {
    const countdownDate = new Date("June 01,2023").getTime();
    interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownDate - now;
      const days = Math.floor(distance / (24 * 60 * 60 * 1000));
      const hours = Math.floor(
        (distance % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
      );
      const minutes = Math.floor((distance % (60 * 60 * 1000)) / (60 * 1000));
      const seconds = Math.floor((distance % (60 * 1000)) / 1000);
      if (interval < 0) {
        clearInterval(interval.current);
      } else {
        setClockDay(days);
        setClockHour(hours);
        setClockMin(minutes);
        setClockSecond(seconds);
      }
    });
  };

  useEffect(() => {
    starterTime();
  });

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <Container className={styles.container}>
      <Row className="justify-content-center p-3">
        <Col md={2} className={styles.wrapper}>
          <h2>{clockDay}</h2>
          <span>Day</span>
        </Col>
        <Col md={2} className={styles.wrapper}>
          <h2>{clockHour}</h2>
          <span>Hours</span>
        </Col>
        <Col md={2} className={styles.wrapper}>
          <h2>{clockMin}</h2>
          <span>Minutes</span>
        </Col>
        <Col md={2} className={styles.wrapper}>
          <h2>{clockSecond}</h2>
          <span>Seconds</span>
        </Col>
      </Row>

      <Row className="justify-content-center pb-4">
        <Col md={5}>
          <Typography
            variant={matches ? "subtitle2" : "body1"}
            fontWeight={600}
            component="div"
          >
            <EventIcon sx={{ color: "#8573ff", fontSize: "30px" }} /> Enrollment
            Start: Feb 15, 2023
          </Typography>

          <Typography
            variant={matches ? "subtitle2" : "body1"}
            fontWeight={600}
            component="div"
          >
            <AlarmOnTwoToneIcon sx={{ color: "#011C39", fontSize: "30px" }} />{" "}
            Course Start: March 03, 2023
          </Typography>
        </Col>
        <Col md={3}>
          <Typography
            variant={matches ? "subtitle2" : "body1"}
            fontWeight={600}
            component="div"
          >
            <AccessTimeTwoToneIcon
              sx={{ color: "#8573ff", fontSize: "30px" }}
            />{" "}
            Class Time: 6:00 to 9:10PM
          </Typography>

          <Typography
            variant={matches ? "subtitle2" : "body1"}
            fontWeight={600}
            component="div"
          >
            <EventTwoToneIcon sx={{ color: "#011C39", fontSize: "30px" }} />{" "}
            Weekly 2 days class
          </Typography>
        </Col>
      </Row>
    </Container>
  );
};

export default CountDown;
